import type { PreloadedState } from '@reduxjs/toolkit';
import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { REDUX_STORAGE_KEY } from '~/constants/other';

import admin from './admin';
import api from './api';
import preferences from './preferences';
import ux from './ux';

const combinedReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  admin,
  ux,
  preferences,
});

export type RootState = ReturnType<typeof combinedReducer>;

// @ts-expect-error REDUX_STORAGE_KEY is provided to window by SSR
const _window: typeof globalThis & { [REDUX_STORAGE_KEY]: PreloadedState<RootState> } = globalThis;

export const makeStore = () =>
  configureStore({
    reducer: combinedReducer,
    preloadedState: _window[REDUX_STORAGE_KEY],
    middleware: gDM =>
      gDM({
        serializableCheck: {
          ignoredActions: ['ux/confirm/fulfilled'],
          ignoredPaths: ['ux.confirmation.callback'],
        },
      }).concat(api.middleware),
  });

export const store = makeStore();
export const reducer = combinedReducer;

export type AppStore = ReturnType<typeof makeStore>;
export type AppDispatch = AppStore['dispatch'];
